<template>
  <v-tooltip v-if="tooltip" bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" slot="activator" class="data-table-header">
        <span>
          {{ text }}
          <span v-if="required" class="red--text font-large"> *</span>
        </span>
        <v-icon size="18">mdi-help-circle-outline</v-icon>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
  <span v-else class="data-table-header">
    {{ text }}
    <span v-if="required" class="red--text"> *</span>
  </span>
</template>

<script>
export default {
  name: "TableHeader",
  props: {
    text: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
